import script from "./DepositCustomer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DepositCustomer.vue?vue&type=script&setup=true&lang=ts"

import "./DepositCustomer.vue?vue&type=style&index=0&id=70c2db7d&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c2db7d"]])

export default __exports__